<button type="button"
        [attr.aria-label]="'CAROUSEL.BACK'|translate"
        [attr.inert]="atStart ? '' : null"
        (click)="scrollBack()">
    <svg xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         version="1.1"
         role="img"
         aria-hidden="true"
         focusable="false">
        <use [attr.xlink:href]="('#' + icon + '-left')"
             [attr.href]="('#' + icon + '-left')">
        </use>
    </svg>
</button>
<div class="track"
     (scroll)="scrollUpdate()"
     [id]="id">
    <ng-content></ng-content>
</div>
<button type="button"
        [attr.aria-label]="'CAROUSEL.FORWARD'|translate"
        [attr.inert]="atEnd ? '' : null"
        (click)="scrollForward()">
    <svg xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         version="1.1"
         role="img"
         aria-hidden="true"
         focusable="false">
        <use [attr.xlink:href]="('#' + icon + '-right')"
             [attr.href]="('#' + icon + '-right')">
        </use>
    </svg>
</button>
